import controller from './link-select-service-controller'

class SelectService {

    $lv
    controller;

    constructor($lv) {
        this.$lv = $lv
        this.init()
    }

    async init() {
        await this.$lv.nextTick()
        this.controller = this.$lv.newInstance(controller)
    }

    async select(...args) {
        return await this.controller.select(...args)
    }
}

export {SelectService}
